import {
  Collapse,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  forwardRef,
  HStack,
  Stack,
} from '@chakra-ui/react'
import get from 'lodash/get'
import React, { createElement } from 'react'
import { Controller, useFormState, useWatch } from 'react-hook-form'
import { RiText } from 'react-icons/ri'
import AdditionField from './AdditionField'

import BaseInput from './BaseInput'
import InputLeftIcon from './InputLeftIcon'

const FollowUp = ({ name, control, fields, editors, getName }) => {
  const value = useWatch({ name, control })
  return (
    <Collapse in={value} unmountOnExit>
      <Stack>
      {fields?.map((field, i) => <AdditionField editors={editors} {...field} name={getName(field)} control={control} key={field.name + i} />)}
      </Stack>
    </Collapse>
  )
}

const BaseEditor = forwardRef(({
  leftIcon = RiText,
  label,
  inputAs = BaseInput,
  name,
  control,
  leftFields,
  rightFields,
  followUpFields,
  editors,
  compact,
  className,
  helper,
  ...props
}, ref) => {
  const { errors } = useFormState({
    control,
    name,
  });
  const getName = (field) => {
    if (field.name.startsWith('.')) return name.replace(/[^.]+\.[^.]+$/, field.name)
    return name.replace(/[^.]+$/, field.name)
  }
  const hasError = get(errors, name)
  return (
    <>
      <FormControl isInvalid={!!hasError} className={className}>
        <HStack alignItems="flex-start" spacing="4">
          {!compact && (leftIcon ? <InputLeftIcon title={label} icon={leftIcon} /> : <FormLabel py="1.5">{label}</FormLabel>)}
          <HStack flex="1" spacing="2">
            {leftFields?.map((field, i) => <AdditionField compact editors={editors} {...field} name={getName(field)} control={control} key={field.name + i} />)}
            {createElement(inputAs, { ...props, control, name, ref, label })}
            {rightFields?.map((field, i) => <AdditionField compact editors={editors} {...field} name={getName(field)} control={control} key={field.name + i} />)}
          </HStack>

        </HStack>
        {helper && <FormHelperText color="gray.300" fontSize="sm" pl="9">{helper}</FormHelperText>}
        <FormErrorMessage mt="1" mb="1" pl="9" fontSize="sm">{hasError?.message}</FormErrorMessage>
      </FormControl>
      {followUpFields && (
        <FollowUp
          name={name}
          control={control}
          fields={followUpFields}
          getName={getName}
          editors={editors}
        />
      )}
    </>
  )
})

export default BaseEditor
